<template>
	<FormTitle
		v-if="title"
		:text="title"
		:required="required"
		:title-active="titleActive"
		:error="errorText ? true : false"
		:disabled="disabled"
		:kizuna-type="kizunaType"
	/>

	<div class="form_group" :class="[formClass, { error: errorClass }]">
		<textarea
			v-model="model"
			:class="formClass"
			:disabled="disabled"
			:maxlength="maxlength"
			class="textArea"
			autocomplete="off"
			tabindex="1"
			:placeholder="placeholder"
			@focus="inputFocus"
			@blur="inputFocus"
		>
		</textarea>
	</div>
	<ErrorText :text="errorText" />
</template>

<script setup>
import ErrorText from "@/components/atoms/ErrorText.vue";
import FormTitle from "@/components/atoms/FormTitle.vue";
import { onMounted, ref, watch } from "vue";

/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	title: String,
	formClass: [String, Array],
	maxlength: Number,
	disabled: Boolean,
	required: Boolean,
	placeholder: String,
	errorText: String,
	kizunaType: Number
});
const model = defineModel();
/* ---------------------------------------------------------------------------
data
---------------------------------------------------------------------------- */
const titleActive = ref(false);
const errorClass = ref("");

/* ---------------------------------------------------------------------------
	modelValueの値を監視
---------------------------------------------------------------------------- */
watch(
	() => model.value,
	(newValue, oldValue) => {
		enteredOrNotCheck(newValue);
	}
);
/* ---------------------------------------------------------------------------
	入力項目の判定
---------------------------------------------------------------------------- */
function enteredOrNotCheck(value) {
	// 必須かつ未入力の場合
	if (props.required && (value == "" || value == null)) {
		errorClass.value = "input-red";
		// 上記以外の場合
	} else {
		errorClass.value = "";
	}
}
/* ---------------------------------------------------------------------------
	捕捉事項の表示
---------------------------------------------------------------------------- */
function inputFocus() {
	titleActive.value = !titleActive.value;
}

/* ---------------------------------------------------------------------------
	mounted
---------------------------------------------------------------------------- */
onMounted(() => {
	// 入力項目の判定
	enteredOrNotCheck(model.value);
});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.textArea {
	width: 100%;
	height: 10rem;
	padding: 1rem;
	font-size: 1.4rem;
	font-weight: normal;
	border-radius: 5px;
	line-height: 2.4rem;
	background: $bg-white2;
	@include trans(0.3);
	// resize: none;
	border: 1px solid $bg-gray2;
	&:focus {
		border: 1px solid $bg-green2;
		background-color: rgba(10, 186, 181, 0.2);
	}
	&-sizeS {
		height: 7rem;
	}
	&.required {
		background-color: rgba(250, 183, 195, 0.3);
	}
	&-read {
		background: unset;
		cursor: pointer;
		border: 1px solid $bg-white1;
		&:focus {
			// transition: unset;
			border: 1px solid $bg-white1;
			background-color: unset;
		}
	}
}
textarea::placeholder {
	color: #d9d9d9;
}
textarea:disabled {
	color: $color-gray4;
	opacity: 1 !important;
	background: #eee;
	&.textArea-read {
		color: $color-gray4;
		background: unset !important;
	}
}
.form_group {
	display: flex;
	align-items: flex-end;
}
.form_group.error .textArea {
	color: $baseTextColor;
	border-color: $bg-red2;
	background-color: rgba(250, 183, 195, 0.2);
}
</style>
